import { createStore } from "vuex";
export default createStore({
  state: {
    user: [],
    cimage: [],
    checkbox: [],
    checktime: [],
  },
});
